import { featureFlagGuard } from '@tundr/feature-flags';
import type { RouteRecordRaw } from 'vue-router';
import { CompanyWelfarePlan } from '@bo/modules/app/company/config/company.types.ts';
import { reversalRoutesDictionary } from './reversal-routes.dictionary.ts';
import { completePlanReversalRoutesDictionary } from './complete-plan-reversal-routes.dictionary.ts';

export const completePlanReversalRoutesConfig: RouteRecordRaw = {
  ...completePlanReversalRoutesDictionary.completePlanReversal.root,
  redirect: {
    name: reversalRoutesDictionary.reversal.list.name,
    query: { tab: CompanyWelfarePlan.COMPLETE },
  },
  beforeEnter: featureFlagGuard(
    'cancel-welfare-source.bo.feature.complete-plan-reversals.release',
    {
      redirect: { name: reversalRoutesDictionary.reversal.list.name },
    },
  ),
  children: [
    {
      ...completePlanReversalRoutesDictionary.completePlanReversal.detail,
      component: () =>
        import(
          '../pages/CompletePlanReversalDetail/CompletePlanReversalDetailPage.vue'
        ),
      props: true,
    },
  ],
};
